import PropertyTreeNode from '../Node/PropertyTreeNode'
import IntegerField from '../../Inputs/IntegerField'

const PropertyTreeIntegerNode = (props) => {
  return <PropertyTreeNode {...props} input={<IntegerField {...props} />} />
}
export default PropertyTreeIntegerNode
